/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppFlavourModel } from '../../models/app-flavour-model';

export interface AdminIdGet$Params {

/**
 * The app flavour ID.
 */
  id: string;
}

export function adminIdGet(http: HttpClient, rootUrl: string, params: AdminIdGet$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<AppFlavourModel>> {
  const rb = new RequestBuilder(rootUrl, adminIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VitalScoreStrictHttpResponse<AppFlavourModel>;
    })
  );
}

adminIdGet.PATH = '/Admin/{id}';
